export const CREATE_LOCATION = "CREATE_LOCATION";
export const UPDATE_LOCATION = "UPDATE_LOCATION";
export const DELETE_LOCATION = "DELETE_LOCATION";
export const FETCH_LOCATIONS = "FETCH_LOCATIONS";
export const LISTEN_TO_SELECTED_LOCATION = "LISTEN_TO_SELECTED_LOCATION";
